module.exports = __webpack_public_path__ + "static/media/img_howto_phone_illust1@2x.6422e6a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_howto_phone_illust1@2x.png
// module id = 1095
// module chunks = 0